// Styles
import styles from './GroupCalculationsTitle.module.css';

export const GroupCalculationsTitle = ({titleName}) => {
  return(
    <h2 className={styles.title}>Group Calculations</h2>
  );
};